/// <reference path="../../../tools/typings/angularjs/angular.d.ts"/>
/// <reference path="./search_interfaces.ts"/>
/// <reference path="./solr_search.ts"/>
/// <reference path="./search_results.ts"/>
/// <reference path="../services.ts"/>

namespace DealerwareWebServices {
    "use strict";

    export class DealerwareSolrSearchSmartFilter implements IDealerwareSolrSearchSmartFilter {
        public  name                :   string;
        public  searchProperty      :   string;
        public  filters             :   string[];

        private _displayTitle       :   string;
        public  displayTitleIcon    :   string;
        private _displayDescription :   string;
        private _displayTooltip     :   string;

        constructor(name? : string,searchProperty? : string,filters? : string[]) {
            this.name = name;
            this.searchProperty = searchProperty;
            this.filters = filters;
        }

        public get displayTitle() : string {
            if (!this._displayTitle) {
                this._displayTitle = this.name;
            }
            return this._displayTitle;
        }

        public set displayTitle(title : string) {
            this._displayTitle = title;
        }

        public get displayDescription() : string {
            if (!this._displayDescription) {
                this._displayDescription = (this.displayTitle + ' (' + this.filters.join(",") + ')')
            }
            return this._displayDescription;
        }

        public set displayDescription(description : string) {
            this._displayDescription = description;
        }

        public get displayTooltip() : string {
            if (!this._displayTooltip) {
                var _t = "Find by cars with the following states.<ul>";
                this.filters.forEach(function(val,idx) {
                    _t = _t + "<li>" + val + "</li>";
                });
                _t = _t + "</ul>";
                this._displayTooltip = _t;
            }
            return this._displayTooltip;
        }

        public set displayTooltip(tooltip : string) {
            this._displayTooltip = tooltip;
        }

        public searchDisplay() : string {
            return this.displayDescription;
        }
    }


    export class DealerwareSolrSearchSmartFilters implements IDealerwareSolrSearchSmartFilters {
        public filters : IDealerwareSolrSearchSmartFilter[] = []

        constructor() {}

        public add(filter : IDealerwareSolrSearchSmartFilter) {
            this.filters.push(filter);
        }

        public search(filterName : string) : IDealerwareSolrSearchSmartFilter[] {
            var _filters : any[] = [];
            this.filters.forEach(function(item : IDealerwareSolrSearchSmartFilter,index : number) {
                //if (item.name.toLowerCase().startsWith(filterName.toLowerCase())) {
                if (!filterName) {
                    filterName = ''
                }
                if (item.name.toLowerCase().indexOf(filterName.toLowerCase()) === 0) {
                     _filters.push(item);
                }
            } );
            return _filters;
        }
    }


    export class DealerwareCollectionSolrSearch extends DealerwareSolrSearch implements IDealerwareCollectionSolrSearch {
        //properties
        public static $inject: string[] = ['$q'];
        protected searchCollection : any;
        public searchFilters : IDealerwareSolrSearchSmartFilters = new DealerwareSolrSearchSmartFilters();

        public locationId: number;

        // constructor
        constructor(public $q : any,public $timeout : any) {
            super($q,$timeout);
        }

        // accessors
        get objectCollection() : any {
            return this.searchCollection;
        }

        set objectCollection(col : any) {
            this.searchCollection = col;
        }

        // methods
        public search(searchArgs? : IDealerwareSolrSearchArgs) : ng.IPromise<{}> {
            var _deferred = this.$q.defer();
            var _self = this;
            var _filters = this.searchFilters.search((searchArgs ? searchArgs.searchArgs.search_text : this.searchArgs.searchArgs.search_text));

            if (_filters && _filters.length > 0) {

                var _data : any = {
                    filter: undefined,
                    location_id: _self.locationId
                };
                _data["filter"] = {};
                var _filter = _filters[0];
                _data["filter"][_filter.searchProperty] = _filter.filters;

                if ((searchArgs && searchArgs.locationId) || this.searchArgs.locationId) {
                    _data["filter"]["location_id"] = searchArgs ? searchArgs.locationId : this.searchArgs.locationId;
                    _data["location_id"] = searchArgs ? searchArgs.locationId : this.searchArgs.locationId;
                }

                _data["live"] = (searchArgs ? searchArgs.live : this.searchArgs.live),
                _data["live_type"] = (searchArgs ? searchArgs.live_type : this.searchArgs.live_type),
                _data["active"] = (searchArgs ? searchArgs.active : this.searchArgs.active),
                _data["unsettled"] = (searchArgs ? searchArgs.unsettled : this.searchArgs.unsettled),
                _data["include_inactive"] = (searchArgs ? searchArgs.include_inactive : this.searchArgs.include_inactive),

                _data["sort_by"] = (searchArgs ? searchArgs.sortBy : this.searchArgs.sortBy),
                _data["sort_direction"] =  (searchArgs ? searchArgs.sortDirection : this.searchArgs.sortDirection)

                this.objectCollection.solr_search_with_filters({
                    params: _data,
                    promise: true
                }).then(
                    function(returnValue : any) {
                        _self.searchResults = new DealerwareSolrSearchResults(_self.$q,_self.$timeout);
                        _self.searchResults.results = returnValue;
                        _deferred.resolve(returnValue);
                    },
                    function(response : any) {
                        console.log("DealerwareCollectionSolrSearch error:",response);
                        _deferred.reject(response);

                    }
                );
            } else {

                this.objectCollection.solr_search({
                    params: {
                        filter: (searchArgs ? searchArgs.searchArgs.search_text : this.searchArgs.searchArgs.search_text),
                        location_id: (searchArgs ? searchArgs.locationId : this.searchArgs.locationId),
                        active: (searchArgs ? searchArgs.active : this.searchArgs.active),
                        live: (searchArgs ? searchArgs.live : this.searchArgs.live),
                        live_type: (searchArgs ? searchArgs.live_type : this.searchArgs.live_type),
                        unsettled: (searchArgs ? searchArgs.unsettled : this.searchArgs.unsettled),
                        include_inactive: (searchArgs ? searchArgs.include_inactive : this.searchArgs.include_inactive),
                        sort_by: (searchArgs ? searchArgs.sortBy : this.searchArgs.sortBy),
                        sort_direction: (searchArgs ? searchArgs.sortDirection : this.searchArgs.sortDirection)
                    },
                    promise: true
                }).then(
                    function(returnValue : any) {
                        _self.searchResults = new DealerwareSolrSearchResults(_self.$q,_self.$timeout);
                        _self.searchResults.results = returnValue;
                        _deferred.resolve(returnValue);
                    },
                    function(response : any) {
                        console.log("DealerwareCollectionSolrSearch error:",response);
                        _deferred.reject(response);
                    }
                );

            }

            return _deferred.promise;
        }

        public autoCompleteSearch(searchArgs? : IDealerwareSolrSearchArgs) : ng.IPromise<{}> {
            var _deferred = this.$q.defer();
            var _self = this;
            var _filters = this.searchFilters.search((searchArgs ? searchArgs.searchArgs.search_text : this.searchArgs.searchArgs.search_text));

            var _results : any = {data: []};

            if (_filters && _filters.length > 0) {
                _results.data.push.apply(_results.data, _filters);
            }
            var _searchText = searchArgs ? searchArgs.searchArgs.search_text : this.searchArgs.searchArgs.search_text;

            if (_searchText && _searchText.length >= 3) {
                this.objectCollection.solr_search({
                    params: {
                        filter: _searchText,
                        location_id: searchArgs ? searchArgs.locationId : this.searchArgs.locationId,
                        active: searchArgs ? searchArgs.active : this.searchArgs.active,
                        live: searchArgs ? searchArgs.live : this.searchArgs.live,
                        live_type: searchArgs ? searchArgs.live_type : this.searchArgs.live_type,
                        unsettled: searchArgs ? searchArgs.unsettled : this.searchArgs.unsettled,
                        include_inactive: searchArgs ? searchArgs.include_inactive : this.searchArgs.include_inactive
                    },
                    promise: true
                }).then(
                    function(returnValue : any) {
                        _results.data.push.apply(_results.data,returnValue.data);
                        _deferred.resolve(_results);
                    },
                    function(response : any) {
                        console.log("DealerwareCollectionSolrSearch error:",response);
                        _deferred.reject(response);
                    }
                );
            } else {
                _deferred.resolve(_results);
            }



            return _deferred.promise;
        }

        public clear() : void {
            this.searchArgs.clear();
            this.searchResults = undefined;
        }

    }

    getDealerwareWebServicesModule().service("DealerwareCollectionSolrSearch", DealerwareCollectionSolrSearch);
}
